import { handleStartupFailure } from "@/bootstrap/startupRecovery";
import { initStartupSentry } from "@/sentry";
import "@/assets/styles.scss";

initStartupSentry();

void import("./app-bootstrap")
	.then(({ bootstrapApp }) => bootstrapApp())
	.catch((error) => {
		void handleStartupFailure(error);
	});
